
// import {DatePicker} from 'Electron Gateway_react_ui'
import './App.css';
import '@/assets/css/animate.min.css'
// import 'Electron Gateway_react_ui/dist/app.css';
import { BrowserRouter, Route, Router, Routes, useRoutes,useLocation } from 'react-router-dom'
import { Suspense,useEffect, useState } from 'react'
import route from './route'
import NavBar from '@/components/NavBar'
import BottomPage from '@/components/BottomPage'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { fetch } from './utils/common';
import testBg from '@/assets/testBg.png'  


function App() {
  const RouteRender = () => {
    const rs = useRoutes(route)
    const location = useLocation()
    useEffect(() => {
      if (document && location?.pathname.indexOf('product')===-1) {  // 可以排除不需要置顶的页面
        if (document?.documentElement || document?.body) {
          document.documentElement.scrollTop = document.body.scrollTop = 0;  // 切换路由时手动置顶
        }
      }
    }, [location?.pathname]);
    return rs
  }
  const [navList,setNav] = useState([])
  const getNavList = ()=>{
    fetch({ url: "/index/product_cate"}).then((res) => {
      console.log('============================]',res)
      setNav(res);
    });
  }
  useEffect(()=>{
    getNavList()
  },[])
  return (
    <div className="App">
      <BrowserRouter>
        {/* <NavBar list={navList} />
        <div className='app_warp'>
          <Suspense fallback={() => <div className='loading'></div>}>
            <RouteRender></RouteRender>
          </Suspense>
        </div>

        <BottomPage /> */}

        <div className='app_warp-test'>
           <img src={testBg} alt="" /> 
        </div>
      </BrowserRouter>

    </div>
  );
}

export default App;
